export const users = [
  {
    id: 1,
    nom: "Bernard",
    prenom: "Lucas",
    email: "lucas.bernard@ecole.fr",
    role: "eleve"
  },
  {
    id: 2,
    nom: "Petit",
    prenom: "Emma",
    email: "emma.petit@ecole.fr",
    role: "eleve"
  },
  {
    id: 3,
    nom: "Durand",
    prenom: "Sophie",
    email: "sophie.durand@ecole.fr",
    role: "prof"
  },
  {
    id: 4,
    nom: "Martin",
    prenom: "Paul",
    email: "paul.martin@parents.fr",
    role: "parent"
  },
  {
    id: 5,
    nom: "Lemoine",
    prenom: "Nathalie",
    email: "n.lemoine@school.fr",
    role: "admin"
  }
];